



















































































































import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { deepCopy } from "@/lib/utility/deep-copy";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IRepairEstimateRequest } from "@/models/repair-estimate-request.entity";
import { WorkshopContractRate } from "@/models/workshop-contract-rate.entity";
import repairEstimateRequestService from "@/services/mrfiktiv/services/repair-estimate-request.service";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";

enum CreateInvoiceWindow {
  FILE = "file",
  FIELDS = "fields"
}

@Component({
  components: {
    ConfirmActionDialog,
    DropAreaMulti
  },
  filters: { simpleDoubleDigitDate }
})
export default class RepairEstimateRequestResponseCard extends mixins(PermissionMixin, RulesMixin) {
  readonly simpleDoubleDigitDate = simpleDoubleDigitDate;

  readonly formatCurrency = formatCurrency;

  readonly getAutocompleteFilter = getAutocompleteFilter;

  readonly CurrencyEnum = CurrencyEnum;

  readonly CreateInvoiceWindow = CreateInvoiceWindow;

  readonly RequestStatusEnum = RequestStatusEnum;

  @Prop()
  value!: IRepairEstimateRequest;

  @Prop()
  token!: string;

  step = CreateInvoiceWindow.FILE;

  valueCopy = deepCopy(this.value);

  isDialogActive = false;

  loading = false;

  isValid = false;

  file: File | null = null;

  get leftText(): string {
    switch (this.step) {
      case CreateInvoiceWindow.FILE:
        return $t("close");
      case CreateInvoiceWindow.FIELDS:
        return $t("back");
      default:
        return "";
    }
  }

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  open() {
    this.valueCopy = deepCopy(this.value);
    if (!this.valueCopy.workshopRate) {
      this.valueCopy.workshopRate = new WorkshopContractRate();
    }

    this.step = CreateInvoiceWindow.FILE;

    this.isDialogActive = true;
  }

  close() {
    this.isDialogActive = false;
  }

  leftClick() {
    switch (this.step) {
      case CreateInvoiceWindow.FILE:
        this.close();
        break;
      case CreateInvoiceWindow.FIELDS:
        this.step = CreateInvoiceWindow.FILE;
        break;
    }
  }

  async confirmRepairEstimateResponse() {
    if (!this.file || !this.valueCopy.number || !this.valueCopy.total) {
      this.$toast.error(this.$t("repairEstimateRequest.response.missingFields"));
      return;
    }

    this.loading = true;
    try {
      const response = await repairEstimateRequestService.respond(this.value.partnerId, this.value.id, this.token, {
        total: this.valueCopy.total,
        number: this.valueCopy.number,
        file: this.file,
        currency: this.valueCopy.currency as CurrencyEnum
      });
      this.$emit("input", response);
    } catch (error) {
      handleError(error);
    } finally {
      this.$toast.success(this.$t("repairEstimateRequest.response.success"));
      this.loading = false;
      this.close();
    }
  }

  @Watch("file", { deep: true })
  onFileChange(file: File) {
    if (file && file.name.endsWith(".pdf") && !this.valueCopy.number) {
      this.valueCopy.number = file.name
        .substring(0, file.name.length - 4)
        .replace(/\s+/g, "") // Remove whitespaces
        .replace(/[^\w\d-]/g, ""); // Remove special characters except alphanumeric and hyphen
      this.step = CreateInvoiceWindow.FIELDS;
      this.$nextTick(() => {
        (this.$refs.startField as HTMLInputElement)?.focus();
      });
    }
  }
}
